module.exports = __webpack_public_path__ + "static/media/whatsapp_page_preview.de167414.png";